import { render, staticRenderFns } from "./Firmwares.vue?vue&type=template&id=7fc48584&scoped=true&lang=pug&"
import script from "./Firmwares.vue?vue&type=script&lang=js&"
export * from "./Firmwares.vue?vue&type=script&lang=js&"
import style0 from "./Firmwares.vue?vue&type=style&index=0&id=7fc48584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc48584",
  null
  
)

export default component.exports